import {LitElement, html, css, nothing} from 'lit';

export class ProjectTagContainerElement extends LitElement {
    static get styles() {
        return css`
        .taglist {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            list-style: none;
            padding: 0;
            margin: 0;
            margin-bottom: 1em;
          }
          .taglabel {
              font-weight: bold;
              font-size: 1.2em;
              margin-bottom: 0.5em;
              display: block;
          }
        `;
    }
    
    static get properties() {
        return {
            projectid: {type: Number},
            type: {type: String},
        };
    }
    

    constructor() {
        super();
        this.addEventListener('addtag', this._addTag);
        this.addEventListener('addnewtag', this._addNewTag);
        this.projectid = 0;
        this.type = '';
    }

    get _slottedChildren() {
        const slot = this.shadowRoot.querySelector('slot');
        return slot.assignedElements({flatten: true});  
    }

    _addTag(e) {
        console.log(e);
        const tag = e.detail.tag;
        if (tag.type === this.type) {
            const foundTag = this._slottedChildren.find(child => child.id === tag.id);
            if (foundTag) {
                // Tag already exists
            } else {
                let tagListElement = this.shadowRoot.querySelector('.taglist');
                tagListElement.appendChild(this._createTagElement(tag));
                this._addBackendTag(tag.name);
            }
        }
    }

    _addNewTag(e) {
        const tagname = e.detail.tagname;
        let tagListElement = this.shadowRoot.querySelector('.taglist');
        tagListElement.appendChild(this._createDummyTagElement(tagname));
        this._addBackendTag(tagname);
    }

    _addBackendTag(tagname) {
        console.log('add tag');
        
        let typestring = '';
        if (this.type === 'universe') {
            typestring = 'property';
        }
        if (this.type === 'character') {
            typestring = 'character';
        }
        if (this.type === 'software') {
            typestring = 'software';
        }
        if (this.type === 'misc') {
            typestring = 'misc';
        }
        var projectUrl = '/api/tag/' + typestring + '/item/add/' + this.projectid + '/' + tagname + '/';

        var myInit = {
            method: 'GET'
        };

        var myRequest = new Request(projectUrl, myInit);

        fetch(myRequest).then(
            console.log('tag added')
        ).catch(function (e) {
            console.log(e);
        });
    }

    _createTagElement(tag) {
        const tagElement = document.createElement('project-tag-element');
        tagElement.id = tag.id;
        tagElement.type = tag.type;
        tagElement.name = tag.name;
        tagElement.approved = tag.approved;
        tagElement.adminoptions = true;
        tagElement.projectid = this.projectid;
        return tagElement;
    }

    _createDummyTagElement(tagname) {
        const tagElement = document.createElement('project-tag-element');
        tagElement.id = 0;
        tagElement.type = this.type;
        tagElement.name = tagname;
        return tagElement;
    }

    _getTypeDescription() {
        if (this.type === 'universe') {
            return 'Universe';
        }
        if (this.type === 'character') {
            return 'Character';
        }
        if (this.type === 'software') {
            return 'Software';
        }
        if (this.type === 'misc') {
            return 'Misc';
        }
        return this.type;
    }

    render() {
        return html`    
            <label class="taglabel" for="${this.type}_tags">${this._getTypeDescription()}</label>
            <div class="taglist" name="${this.type}_tags">
                <slot><slot>
            </div>
        `;
    }
}
window.customElements.define('project-tag-container-element', ProjectTagContainerElement);